import Text from '../../components/Text';
import { fontSizes, pdfsPath } from '../../constants/constants';
import subscribeFunctional from './index.function';
import { SubscribeCard, SuitabilityModal } from './components';
import { Formik } from 'formik';
import CustomInput from '../../components/CustomInput';
import ViewReverse from '../../components/ViewReverse';
import ErrorText from '../../components/ErrorText';
import { formatNumbers } from '../../utils/utils';
import Button from '../../components/Button';
import CustomCheckbox from '../../components/CustomCheckbox';
import CustomModal from '../../components/CustomModal';
import dayjs from 'dayjs';
import SarSymbol from '../../components/SarSymbol';
import LoaderModal from '../../components/LoaderModal';
import { Dropdown } from '../../components';
import { DocumentView } from '../Contact/components';
import ViewItems from '../../components/ViewItems';
import { order_schema, order_validation_schema } from '../../validations_schemas/order_validation_schema';
import { ReactSVG } from 'react-svg';
import icons from '../../constants/icons';
import { getFundDetail } from '../../store/actions/fund-action';

const InternalUnitExchange = () => {
  const {
    dispatch,
    buyCloseEndFunds,
    fund_detail,
    TextWeight,
    fund_loading,
    subscribeData,
    getContentKey,
    handleReviewOrder,
    onVerify,
    reviewModal,
    setReviewModal,
    toogleReviewModal,
    fund_document_loading,
    subscription,
    vat,
    isSuitabilityModal,
    setIsSuitabilityModal,
    handleGenerateSuitability,
    image,
    setImage,
    navigate,
    isArabic,
  } = subscribeFunctional();

  return (
    <div className='min-h-full'>
      <ViewReverse className={'gap-5 items-center'}>
        <ReactSVG src={icons?.backSmall} className={`cursor-pointer ${isArabic ? 'rotate-180' : ''}`} onClick={() => navigate(-1)} />
        <Text text={getContentKey('heading')} color='text-black' size={fontSizes.h18} weight={TextWeight.bold} />
      </ViewReverse>
      <div className='border border-grey rounded-xl mt-8 py-5 px-5 shadow-light'>
        <Formik
          validationSchema={order_validation_schema}
          initialValues={order_schema}
          validateOnChange={false}
          validateOnMount={false}
          validateOnBlur={false}
          onSubmit={(values, functions) => handleReviewOrder(values, functions?.resetForm)}
        >
          {({ handleSubmit, setFieldValue, setFieldError, values, errors, resetForm }) => {
            const is_valid = values?.fundName && values?.amount && values?.agree_terms;

            return (
              <div className='mt-2'>
                <ViewReverse>
                  <div className='w-full sm:w-1/2'>
                    <Dropdown
                      label={getContentKey('fund_sar')}
                      selectedValue={values?.fundName}
                      valueKey={'fundName'}
                      options={buyCloseEndFunds?.fundMaster}
                      onSelect={(val) => {
                        setFieldValue('fundName', val);
                        dispatch(getFundDetail(val?.fundId));
                      }}
                      isRequired={true}
                    />
                  </div>
                </ViewReverse>

                <div className='my-4'>
                  <SubscribeCard item={fund_detail} isSubscribe={false} />
                </div>

                <Text
                  text={getContentKey('view_suitability_report') + ' *'}
                  size={fontSizes.h14}
                  weight={TextWeight.semiBold}
                  isTruncate={false}
                  className={'underline cursor-pointer block'}
                  color='text-primary'
                  onClick={() => handleGenerateSuitability()}
                />
                <ErrorText text={errors?.read_suitability_report} />

                <ViewReverse>
                  <div className='w-full sm:w-1/2 pt-2 sm:pt-4'>
                    <CustomInput
                      label={getContentKey('label_unit')}
                      placeholder={getContentKey('unit_placeholder')}
                      isRounded
                      type='number'
                      value={values.amount}
                      onChange={(e) => {
                        const amount = e.target.value;
                        setFieldValue('amount', amount);
                        setFieldError('amount', null);
                      }}
                      isError={errors?.amount}
                      isRequired
                    />
                  </div>
                </ViewReverse>
                <ErrorText text={getContentKey(errors?.amount)} />
                <div className='pt-3'>
                  <Text text={getContentKey('applicable_transaction')} weight={TextWeight.light} isTruncate={false} />
                </div>
                {/* <ViewReverse>
                  <ViewItems className={'w-full md:w-1/2 pt-4'}>
                    <DocumentView image={image} setImage={setImage} />
                  </ViewItems>
                </ViewReverse> */}

                <CustomCheckbox
                  isChecked={values?.agree_terms}
                  disabled={fund_loading}
                  className={'mt-2 sm:mt-4'}
                  onClick={() => setFieldValue('agree_terms', !values?.agree_terms)}
                  label={
                    <>
                      {getContentKey('understand_agree')}{' '}
                      <Text
                        text={getContentKey('agree_term')}
                        color='text-primary underline text-primary'
                        isTruncate={false}
                        className={'inline cursor-pointer'}
                        onClick={() => {
                          window.open(pdfsPath.terms_conditions, '_blank');
                        }}
                      />
                    </>
                  }
                />

                <div className='border-t border-grey h-1 mt-3 w-full'></div>

                <ViewReverse className='gap-2 sm:gap-3 mt-2 sm:mt-4'>
                  <Button
                    text={getContentKey('review_btn')}
                    bgColor='bg-primary'
                    className={'w-full sm:w-fit sm:px-10 rounded-lg capitalize py-2 text-center'}
                    onClick={() => {
                      setFieldValue('is_submit', true);
                      handleSubmit();
                    }}
                    isDisabled={!is_valid || fund_loading}
                  />
                  <Button
                    text={getContentKey('clear_btn')}
                    bgColor='bg-white'
                    color='text-primary'
                    className={'w-full sm:w-fit sm:px-16 rounded-lg capitalize py-2 text-center border border-primary'}
                    onClick={resetForm}
                  />
                </ViewReverse>

                <SuitabilityModal
                  open={isSuitabilityModal}
                  agree={values?.read_suitability_report}
                  toogleAgree={() => setFieldValue('read_suitability_report', !values?.read_suitability_report)}
                  onPressOkay={() => {
                    setIsSuitabilityModal(false);
                    values?.is_submit && handleSubmit();
                  }}
                />
              </div>
            );
          }}
        </Formik>
      </div>

      <CustomModal isOpen={reviewModal} heading={getContentKey('confirmation_heading')} isCenter={false} isFullWidth onClose={toogleReviewModal}>
        <Text text={getContentKey('order_summary')} color='text-text-grey/60' size={fontSizes.h14} />

        <ViewReverse className={'justify-between border-b py-2 border-b-grey mt-3'}>
          <Text text={getContentKey('fund')} size={fontSizes.h14} />
          <Text text={fund_detail?.fundName} size={fontSizes.h14} color='text-primary' weight={TextWeight.semiBold} />
        </ViewReverse>

        <ViewReverse className={'justify-between border-b py-2 border-b-grey'}>
          <Text text={getContentKey('terms_condition')} size={fontSizes.h14} />
          <ViewReverse className={'gap-2 items-center cursor-pointer'} onClick={() => window.open(pdfsPath.terms_conditions, '_blank')}>
            <Text text={dayjs().format('DD MMM, YYYY')} size={fontSizes.h14} color='text-primary' weight={TextWeight.semiBold} />
            <ReactSVG src={icons.viewActionbtn} />
          </ViewReverse>
        </ViewReverse>
        <ViewReverse className={'justify-between border-b py-2 border-b-grey'}>
          <Text text={getContentKey('label_unit')} size={fontSizes.h14} />
          <Text text={subscribeData?.amount} size={fontSizes.h14} color='text-primary' weight={TextWeight.semiBold} />
        </ViewReverse>
        {/* <ViewReverse className={'justify-between border-b py-2 border-b-grey'}>
          <Text text={getContentKey('subscription_fee')} size={fontSizes.h14} />
          <ViewReverse>
            <SarSymbol color={'text-primary'} />
            <Text
              text={subscription}
              size={fontSizes.h14}
              color='text-primary'
              weight={TextWeight.semiBold}
            />
          </ViewReverse>
        </ViewReverse> */}
        {/* <ViewReverse className={'justify-between border-b py-2 border-b-grey'}>
          <Text text={getContentKey('vat')} size={fontSizes.h14} />
          <ViewReverse>
            <SarSymbol color={'text-primary'} />
            <Text
              text={formatNumbers(vat)}
              size={fontSizes.h14}
              color='text-primary'
              weight={TextWeight.semiBold}
            />
          </ViewReverse>
        </ViewReverse> */}
        {/* {image && (
          <ViewReverse
            className={'justify-between border-b py-2 border-b-grey'}
          >
            <Text text={getContentKey('document')} size={fontSizes.h14} />
            <ViewReverse
              className={'gap-2 items-center cursor-pointer'}
              onClick={() => {
                const fileURL = URL.createObjectURL(image);
                window.open(fileURL, '_blank');
              }}
            >
              <Text
                text={image?.name}
                size={fontSizes.h14}
                color='text-primary'
                weight={TextWeight.semiBold}
              />
              <ReactSVG src={icons.viewActionbtn} />
            </ViewReverse>
          </ViewReverse>
        )} */}
        <ViewReverse className={'justify-between py-2'}>
          <Text text={getContentKey('date')} size={fontSizes.h14} />
          <Text text={dayjs().format('DD MMM, YYYY')} size={fontSizes.h14} color='text-primary' weight={TextWeight.semiBold} />
        </ViewReverse>

        <ViewReverse className='items-center w-full justify-end gap-2 mt-3'>
          <Button
            text={getContentKey('review_btn')}
            bgColor='bg-primary'
            className={'w-full px-0 text-center border border-orange'}
            onClick={onVerify}
            loading={fund_loading}
          />
          <Button
            text={getContentKey('edit')}
            bgColor='bg-white'
            color='text-primary'
            className={'w-full rounded-lg capitalize py-2 text-center border border-primary'}
            onClick={() => {
              setReviewModal(false);
            }}
          />
        </ViewReverse>
      </CustomModal>

      <LoaderModal open={fund_document_loading} />
    </div>
  );
};

export default InternalUnitExchange;
